var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-chart',{attrs:{"class-names":"mt-8","title":"Articles dans discover","subTitle":"VS total","series":_vm.series,"labels":_vm.labels,"yAxis":_vm.yAxis,"colors":_vm.colors,"formatter":_vm.formatter}})}
var staticRenderFns = []

export { render, staticRenderFns }